import React from "react";
import includes from "lodash/includes";
import PropTypes from "prop-types";

import CheckBox from "components/Checkbox";
import { LimitationsContext } from "utils/Authenticated";

import types from "./types";

import styles from "./EventFilter.css";

class EventFilter extends React.Component {
  constructor(props) {
    super(props);
    this.getTypes = this.getTypes.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(option) {
    const { onFilter, selectedFilters } = this.props;
    const wasSelected = selectedFilters.find((f) => f === option);

    if (wasSelected) return onFilter(selectedFilters.filter((f) => f !== option));

    return onFilter([...selectedFilters, option]);
  }

  getTypes() {
    const limitations = this.context;

    return types
      .filter(
        (t) =>
          !includes(["viewing", "call", "due_proposal"], t.type) || !includes(limitations, "deals")
      )
      .filter(
        (t) =>
          !includes(
            ["lease_expiration", "lease_start", "space_available", "due_proposal"],
            t.type
          ) || !includes(limitations, "assets")
      );
  }

  render() {
    const { selectedFilters } = this.props;

    return (
      <div className={styles.root}>
        {this.getTypes().map((type) => (
          <div className={styles.filter} key={type.type}>
            <CheckBox
              isChecked={!!selectedFilters.find((f) => f === type.type)}
              onChange={() => this.handleSelect(type.type)}
            >
              <div className={styles.label} style={{ background: type.color }}>
                {type.title}
              </div>
            </CheckBox>
          </div>
        ))}
      </div>
    );
  }
}

EventFilter.contextType = LimitationsContext;

EventFilter.propTypes = {
  selectedFilters: PropTypes.arrayOf(PropTypes.string),
  onFilter: PropTypes.func.isRequired,
};

EventFilter.defaultProps = {
  selectedFilters: [],
};

export default EventFilter;
